// Hosts allowed by `images.remotePatterns` in next.config.ts. Anything else
// (e.g. an admin-pasted URL on another CDN) must bypass the Next.js image
// optimizer, otherwise <Image> throws for an unconfigured host.
const OPTIMIZABLE_HOSTS = new Set(["flagcdn.com", "i.ytimg.com"])

const supabaseHost = (() => {
  try {
    return process.env.NEXT_PUBLIC_SUPABASE_URL
      ? new URL(process.env.NEXT_PUBLIC_SUPABASE_URL).hostname
      : null
  } catch {
    return null
  }
})()

/** True when `src` can be served through the Next.js image optimizer. */
export function canOptimizeImage(src: string): boolean {
  if (src.startsWith("/") && !src.startsWith("//")) return true
  try {
    const { protocol, hostname } = new URL(src)
    if (protocol !== "https:") return false
    if (OPTIMIZABLE_HOSTS.has(hostname)) return true
    return supabaseHost ? hostname === supabaseHost : hostname.endsWith(".supabase.co")
  } catch {
    return false
  }
}
